import { render } from "./IndexConfigVehicule.vue?vue&type=template&id=c36d838e"
import script from "./IndexConfigVehicule.vue?vue&type=script&lang=js"
export * from "./IndexConfigVehicule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__